import {computed, observable, action, extendObservable, untracked} from 'mobx';


export class Form { 
  fields = observable.map();

  valInit = observable.map();
  valDirty = observable.map();

  dirtyMap = observable.map();
  visitedMap = observable.map();

  fieldCheck(dct) {
    for(let k in dct) {
      if(this.fields && !this.fields.has(k)) {
        throw new Error(`Field ${k} not allowed for this form.`);
      }    
    }
  }
  
  @computed get rawValues() {
    let result = {};
    for(let [k, v] of this.valInit) {
      result[k] = this.dirtyMap.get(k) ? this.valDirty.get(k) : this.valInit.get(k);
    }
    return result;
  }

  @computed get computedRawValues() {
    let result = {};
    for(let k of this.fields.keys()) {
      result[k] = computed(() => {
        return this.dirtyMap.get(k) ? this.valDirty.get(k) : this.valInit.get(k)
      });
    }
    return observable(result)
  }

  @computed get dirtyValues() {
    let result = {};
    for(let [k, v] of this.valInit) {
      if(this.dirtyMap.get(k)) {
        result[k] = this.valDirty.get(k);
      }
    }
    return result;    
  }

  @action.bound commitValue(fieldName, value) {
    this.fieldCheck({[fieldName]:value});
    this.dirtyMap.set(fieldName, true);
    this.valDirty.set(fieldName, value);
  }

  @action.bound handleBlur(fieldName) {
    this.fieldCheck({[fieldName]:true});
    this.visitedMap.set(fieldName, true);
  }

  @action.bound reset(values) {
    this.fieldCheck(values);
    for(let k in values) {
      this.valInit.delete(k);
      this.valDirty.delete(k);
      this.dirtyMap.delete(k);
      this.visitedMap.delete(k);
    }
    this.init(values);
  }

  @action.bound init(values) {
    this.fieldCheck(values);
    for(let k in values) {
      this.valInit.set(k, values[k]);
      this.valDirty.set(k, values[k]);
    }    
  }

  @action.bound defaultReset() {
    let values = {};
    for(let [k,v] of this.fields) {
      values[k] = v.initValue;
    }
    this.reset(values);
  }
}


// WEBPACK FOOTER //
// ./src/view/Form.js